import sanitize from 'sanitize-filename';

export function sanitizeFilename(filename: string): string {
  const percentReplaced = filename.replaceAll('%', '_');
  return sanitize(percentReplaced, { replacement: '_' });
}
